const OUTPUT_SUCCESS_MESSAGE =
  "Optimal Assignment of Judges to Projects is Complete";
const OUTPUT_ERROR_MESSAGE =
  "Assignment of Judges to Projects is impossible. Please edit this Excel File.";

const REQUEST_STATUS = {
  INITIAL: "INITIAL",
  SUCCESS: "SUCCESS",
  IN_PROGRESS: "IN_PROGRESS",
  ERROR: "ERROR",
};

const FILE_NAME = {
  Judges: "Output File - Judge Assignments.xlsx",
  Scores: "Output File - Preference Scores.xlsx",
  Projects: "Output File - Project Assignments.xlsx",
};

export {
  OUTPUT_SUCCESS_MESSAGE,
  OUTPUT_ERROR_MESSAGE,
  REQUEST_STATUS,
  FILE_NAME,
};
